<template>
  <LoaderComp v-if="!loaded"/>
  <HeaderComp v-show="loaded"/>

  <div v-if="filter !== false">
    <CardsComp :filter="filter" v-if="filter !== null && !xumo && equipment != 'XUMO'" />
    <PlayerComp
      @playerLoaded="playerInit"
      @playerError="playerError"
      :badEquipment="filter === null || xumo"
      :class="{xumoMargin: equipment == 'XUMO'}"
    />
  </div>

  <EmptyEquipment v-else/>

</template>

<script>
import LoaderComp from './components/LoaderComp.vue'
import HeaderComp from './components/HeaderComp.vue'
import CardsComp from './components/CardsComp.vue'
import PlayerComp from './components/PlayerComp.vue'
import EmptyEquipment from './components/EmptyEquipment.vue'

import EV_internet from './equipmentsVariants/internet.json'
import EV_internetWifi from './equipmentsVariants/internetWifi.json'
import EV_internetTv from './equipmentsVariants/internetTv.json'
import EV_tv from './equipmentsVariants/tv.json'
import EV_internetWifiTv from './equipmentsVariants/internetWifiTv.json'

export default {
  name: 'App',
  components: {
    LoaderComp,
    HeaderComp,
    CardsComp,
    PlayerComp,
    EmptyEquipment,
  },
  data() {
    return {
      loaded: false,
      filter: false,
      EV_internet,
      EV_internetWifi,
      EV_internetTv,
      EV_tv,
      EV_internetWifiTv,
      equipment: null,
    }
  },
  methods:{
    playerInit(){
      this.loaded = true
      document.body.classList.remove('noScroll')
    },
    playerError(){
      this.filter = false
      this.loaded = true
    }
  },
  mounted() {

    console.log('--', new Date());

    const urlParams = new URLSearchParams(window.location.search);

    this.filter = null

    for (const [key, value] of urlParams.entries()) {
      if (key.toLowerCase() === 'equipment') {
        this.equipment = value.toUpperCase();
      }
    }
  
    if(this.equipment){
      if(this.EV_internet.includes(this.equipment)){
        this.filter = 'internet'
      }else if(this.EV_internetWifi.includes(this.equipment)){
        this.filter = 'internetWifi'
      }else if(this.EV_internetTv.includes(this.equipment)){
        this.filter = 'internetTv'
      }else if(this.EV_tv.includes(this.equipment)){
        this.filter = 'tv'
      }else if(this.EV_internetWifiTv.includes(this.equipment)){
        this.filter = 'internetWifiTv'
      }
    }

    console.log('==>' , this.filter);

    if(!this.filter){
      document.body.classList.remove('noScroll')
    }

  },
  computed:{
    xumo(){
      const urlParams = new URLSearchParams(window.location.search);
      let XumoFlag = '';
      let equipment = '';

      for (const [key, value] of urlParams.entries()) {
        if (key.toLowerCase() === 'xumoflag') {
          XumoFlag = value.toUpperCase();
        }
        if (key.toLowerCase() === 'equipment') {
          equipment = value.toUpperCase();
        }
      }

      if(
        (equipment == 'XUMO' && XumoFlag != 'TRUE')
      ){
        return true
      }
      return false
    }
  }
}
</script>

<style>
@charset "UTF-8";
* {
  margin: 0;
  padding: 0;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}

@font-face {
  font-family: "Gotham-Bold";
  src: url("@/assets/fonts/Gotham-Bold.otf") format("opentype");
  font-display: block;
  font-weight: normal;
}
@font-face {
  font-family: "Gotham-Light";
  src: url("@/assets/fonts/Gotham-Light.otf") format("opentype");
  font-display: block;
  font-weight: normal;
}
@font-face {
  font-family: "SpectrumSansRg";
  src: url("@/assets/fonts/SpectrumSansRg.otf") format("opentype");
  font-display: block;
  font-weight: normal;
}

@font-face {
	font-family: "iconsFont";
	src: url("@/assets/fonts/iconsFont.woff") format("woff");
	font-display: block;
	font-weight: normal;
}

body {
  font-family: "Gotham-Light", sans-serif;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  color: #000;
  font-size: 16px;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  width: 100%;
}

.noScroll{
  max-height: 100vh;
  overflow: hidden;
}

</style>
<style scoped>
.xumoMargin{
  margin-top:30px;
}
</style>